module.exports = __webpack_public_path__ + "img/Gallery_2_08.ecf84fa1.jpeg";